<template>
	<v-card class="mx-auto elevation-12" style="max-width: 500px">
		<v-card-title class="text-center headline font-weight-black">
			<v-spacer></v-spacer>
			Forgot Password
			<v-spacer></v-spacer>
		</v-card-title>
		<v-card-subtitle id="err-message" class="text-center red--text">
			{{ this.errMsg }}
		</v-card-subtitle>
		<v-card-text>
			<v-form v-model="validForm">
				<v-row class="justify-center text-center" dense>
					<v-col cols="12">
						<v-text-field
							v-model="email"
							label="Email"
							name="email"
							hint="Enter your email to receive your password reset code"
							persistent-hint
							type="text"
							outlined
							:rules="emailRules"
						/>
					</v-col>
					<v-col cols="12 mt-4">
						<v-btn
							class="mb-2 py-5 px-10 text-none"
							depressed
							large
							rounded
							color="primary"
							:disabled="!validForm || loadingRequest"
							:loading="loadingRequest"
							@click="sendCode"
							>Send Code
						</v-btn>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-row class="justify-center text-center" dense>
				<v-col clos="12">
					Already have a code?
					<router-link to="/reset-password">Reset Password</router-link>
				</v-col>
			</v-row>
		</v-card-actions>
	</v-card>
</template>

<script>
import { Auth } from 'aws-amplify';
import { Tracking } from '@/utils/tracking';

export default {
	name: 'UserForgotPassword',
	data: () => ({
		loadingRequest: false,
		email: '',
		code: '',
		errMsg: '',
		validForm: false,
		emailRules: [v => !!v || 'This field is required', v => /@/.test(v || '') || 'Please enter a valid email'],
	}),
	mounted() {
		Tracking.track('ForgotPassword', {});
		const username = this.$route.query && this.$route.query.username;
		if (username) this.email = username;
	},
	methods: {
		async sendCode() {
			this.loadingRequest = true;
			try {
				await Auth.forgotPassword(this.email.toLowerCase().trim());
				this.$router.push({ name: 'ResetPassword', query: { username: this.email } });
			} catch (error) {
				this.errMsg = error.message;
				document.getElementById('err-message').scrollIntoView();
			} finally {
				this.loadingRequest = false;
			}
		},
	},
};
</script>
